import { render, staticRenderFns } from "./AdmissionsJournalIndex.vue?vue&type=template&id=642f3b89"
import script from "./AdmissionsJournalIndex.vue?vue&type=script&lang=js"
export * from "./AdmissionsJournalIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports